import type { ISurvey, ISurveyQuestion, ISurveyQuestionGroup } from '@/types/Data'
import type {
  ICreateSurveyQuestionGroup,
  ICreateSurveyQuestionImage,
  IGetSurveyList,
  IPayloadSurvey,
  IUpdateSurveyQuestion,
  IUpdateSurveyQuestionGroup,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class SurveyServices extends BaseService {
  GetSurveyList(payload: IGetSurveyList) {
    return this.GET<ISurvey[]>(this.PATHS.GET_SURVEY_LIST, payload)
  }

  CreateSurvey(data: IPayloadSurvey) {
    return this.POST<void>(this.PATHS.CREATE_SURVEY, data)
  }

  UpdateSurvey(data: IPayloadSurvey) {
    return this.POST<void>(this.PATHS.UPDATE_SURVEY, data)
  }

  DeleteSurvey(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_SURVEY, { Id })
  }

  GetSurveyQuestionGroupList(SurveyId: string) {
    return this.GET<ISurveyQuestionGroup[]>(this.PATHS.GET_SURVEY_QUESTION_GROUP_LIST, {
      SurveyId,
    })
  }

  CreateSurveyQuestionGroup(data: ICreateSurveyQuestionGroup) {
    return this.POST<string>(this.PATHS.CREATE_SURVEY_QUESTION_GROUP, data)
  }

  UpdateSurveyQuestionGroup(data: IUpdateSurveyQuestionGroup) {
    return this.POST<void>(this.PATHS.UPDATE_SURVEY_QUESTION_GROUP, data)
  }

  DeleteSurveyQuestionGroup(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_SURVEY_QUESTION_GROUP, { Id })
  }

  UpdateSurveyQuestion(data: IUpdateSurveyQuestion) {
    return this.POST<ISurveyQuestion>(this.PATHS.UPDATE_SURVEY_QUESTION, data)
  }

  DeleteSurveyQuestion(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_SURVEY_QUESTION, { Id })
  }

  CreateSurveyQuestionImage(data: ICreateSurveyQuestionImage) {
    return this.POST<void>(this.PATHS.CREATE_SURVEY_QUESTION_IMAGE, JsonToFormData(data))
  }

  CloneSurvey(SurveyId: string) {
    return this.POST<string>(this.PATHS.CLONE_SURVEY, { SurveyId })
  }

  ResetSurvey(SurveyId: string) {
    return this.POST<string>(this.PATHS.RESET_SURVEY, { SurveyId })
  }
}
